import { DocumentListCard } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const SLIDER_ITEM_GAP = '8px'
export const AMF_TASK_CARD_MUTED_COLOR = '#BCBCBE'

export const AMFTaskCard = styled(DocumentListCard)`
  padding: 16px 8px 8px;
  border: 1.5px solid ${AMF_TASK_CARD_MUTED_COLOR};
`

export const SliderItem = styled.div<{ $hasGap?: boolean }>`
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  ${({ $hasGap }) =>
    $hasGap && `border-right: ${SLIDER_ITEM_GAP} solid transparent;`}
`
